import React from "react"
import { connect } from "react-redux"
import { FormikProps } from "formik/dist/types"
import { Form as BootstrapForm } from "react-bootstrap"
import classNames from "classnames"
import PlacesAutocomplete from "./shared/PlacesAutocomplete"
import { updateSuggestionsDispatchAction } from "../../../state/geoMap/dispatchActions"
import translations from "../../../translations"

interface PropsType {
  suggestions: any;
  updateSuggestionsActionHandler: any;
  formProps: FormikProps<any>;
  language: string;
  hideLabel: boolean;
}

const LocationField = (props: PropsType) => {
  const {
    suggestions,
    updateSuggestionsActionHandler,
    formProps,
    language,
    hideLabel,
  } = props

  const { setFieldValue, values, errors, touched, handleChange } = formProps

  return (
    <div className={classNames("row mx-0", hideLabel ? "" : "mb-3")}>
      <BootstrapForm.Label
        className={classNames("m-0 px-0 d-flex", hideLabel ? "col-1" : "col-3")}
      >
        <svg className="label-icon">
          <use xlinkHref="#targer-icon" fill="#9A9BA6" />
        </svg>
        {!hideLabel && (
          <span>{translations("locationLeftSearchBar", language)}</span>
        )}
      </BootstrapForm.Label>
      <BootstrapForm.Group
        className={classNames(hideLabel ? "col-11" : "col-9", "m-0 pr-0")}
      >
        <PlacesAutocomplete
          suggestions={suggestions}
          onChangeHandler={(e) => {
            handleChange(e)
            if (e.target.value) updateSuggestionsActionHandler(e.target.value)
          }}
          className="m-0 form-control"
          name="where"
          value={values.where}
          setFieldValue={setFieldValue}
          isInvalid={(!!errors.where && !!touched.where) || false}
          disabled={false}
        />
        <BootstrapForm.Control.Feedback type="invalid">
          {errors.where}
        </BootstrapForm.Control.Feedback>
        <svg className="svg-icon">
          <use xlinkHref="#search-icon" fill="#6A737B" />
        </svg>
      </BootstrapForm.Group>
    </div>
  )
}

const mapStateToProps = (state) => ({
  suggestions: state.geoMap.placeSuggestions,
  language: state.application.appParameters.language,
})

const mapDispatchToState = (dispatch) => ({
  updateSuggestionsActionHandler: (e) =>
    dispatch(updateSuggestionsDispatchAction(e)),
})

export default connect(mapStateToProps, mapDispatchToState)(LocationField)
